export default {
    data(){
        return{
    cn: {
      /* ===================== ABOUT US TITLE ======================*/
  
      about_us_title: "公司简介",
  
      /* ===================== ABOUT US ======================*/
  
      about_us_description: `
      云翰虹章成立于2022年6月，其总部位于中国宁波，业务涵盖影视、文化旅游、数字资产和AIGC（人工智能生成内容）等领域。云翰虹章秉持“创新、协作、共赢”的核心价值观，拥有一支高效且专业的团队，为客户提供全面的一站式服务，致力于成为全球化的综合性企业。
      
      在影视领域，公司参与制作了多部高质量影视作品，收获了广泛的赞誉。在文化旅游方面，云翰虹章通过创新的旅游项目和文化活动，将高科技融入生活，吸引了大量游客并促进了地方经济的发展。数字资产领域，公司通过数字化技术保护并展示博物馆文物，为文化传承提供了新的途径。而在AIGC方面，云翰虹章运用先进的人工智能技术，为客户提供个性化的内容创作服务，显著提升了用户体验。
      
      在产学研合作方面，云翰虹章与多所高校和研究机构建立了长期合作关系，推动科技创新和人才培养。通过与学术界和产业界的紧密合作，云翰虹章不仅紧跟技术前沿，还将最新的科技应用于产品和服务中，加速产业转型升级。
      
      云翰虹章将继续秉持“创新、协作、共赢”的核心价值观，不断提升自身实力，为客户提供更优质的服务，助力中国文化走向世界。

      `,
      contact_us_title: "联系我们",
      contact_us_description: `
      邮箱 : dankao.chen@nxtech.pub

      如有任何问题或合作意向，请随时通过邮箱联系我们。我们将竭诚为您提供服务。

      `,
    }
  }
  }
  };
  